import type { IconSvgObject } from './types';

const FileAudioIcon: IconSvgObject = [
  ["path", { d: "M20 11V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 16.5H13.5C13.2239 16.5 13 16.7239 13 17V19C13 19.2761 13.2239 19.5 13.5 19.5H16L20 22V14L16 16.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileAudioIcon;
